import React, { useState } from "react";
import { Box, IconButton, useMediaQuery } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { GooglePlacesSearch, useModules } from '@schamburg-web/components';

const GooglePlacesSearchWrapper = (props) => {
  const [showSearch, setShowSearch] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Box sx={{ position: "relative" }}>
      {isMobile ? (
         <Box
            sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end', // keeps the icon on the right
            gap: 1,
            position: 'relative',
            width: '240px',   
            height: 48,
            }}
        >
           
            <Box
                sx={{
                    visibility: showSearch ? 'visible' : 'hidden',
                    opacity: showSearch ? 1 : 0,
                }}
                >
              <GooglePlacesSearch {...props} />
            </Box>
          
            <IconButton
              color="primary"
              onClick={() => setShowSearch(!showSearch)}
              sx={{
                boxShadow: 2,
                "&:hover": { backgroundColor: "#f0f0f0" },
                width: 50,   
                height: 50,
                flexShrink: 0,
              }}
              className='map-control-on map-control-icon-large'
              
            
            >
              <SearchIcon />
            </IconButton>
        </Box>
      ) : (
        // Desktop always shows full search
        <GooglePlacesSearch {...props} />
      )}
    </Box>
  );
};

export default GooglePlacesSearchWrapper;
